// Show the correct tab when the downloads form has been submitted on a single
// product page.
$(window).on('load', function () {
    if (window.location.hash != '#tab-downloads') {
        return;
    }

    // Show the tab
    $('#tab-title-downloads > a').trigger('click');

    // Scroll to the tab
    $('html, body').animate({
        scrollTop: $('.woocommerce-tabs').offset().top - $('.site-fixed-header').height()
    });
});
